import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';

export function Callback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    async function handleCallback() {
      try {
        await refresh();
        const res = await fetch('/auth/me', { credentials: 'include' });
        if (!res.ok) {
          navigate('/login?error=Authentication failed', { replace: true });
          return;
        }
        const user = await res.json();
        if (!user.onboarding_completed) {
          navigate('/onboarding', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch {
        navigate('/login?error=Authentication failed', { replace: true });
      }
    }

    handleCallback();
  }, [refresh, navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-surface-0">
      <div className="flex flex-col items-center gap-4">
        <div className="h-8 w-8 spinner-gradient" />
        <p className="text-sm text-text-secondary">Completing sign in...</p>
      </div>
    </div>
  );
}
